import { initSentry } from "./app/lib/sentry";
import { createRoot } from "react-dom/client";
import App from "./app/App.tsx";
import { ErrorBoundary } from "./app/components/ErrorBoundary";
import { registerServiceWorker } from "./app/lib/registerSW";
import { mountAfterInitialPlatformPaint } from "./app/lib/platformChrome";
import "./styles/index.css";

// Start monitoring before rendering, but keep the optional SDK out of the
// initial application chunk (and do not download it at all without a DSN).
initSentry();

// Request persistent storage so the browser doesn't evict IndexedDB under
// storage pressure. Fire-and-forget: errors are silently ignored.
(async () => {
  try {
    if (navigator.storage?.persisted && navigator.storage?.persist) {
      const already = await navigator.storage.persisted();
      if (!already) {
        await navigator.storage.persist();
      }
    }
  } catch (e) {
    if (import.meta.env.DEV) console.warn("[lexibit] storage.persist() failed:", e);
  }
})();

void mountAfterInitialPlatformPaint(() => {
  // Prompts before activating a new build; no-op in dev. Host lifecycle has
  // been resolved above, so the worker consumes the same platform contract.
  registerServiceWorker();
  createRoot(document.getElementById("root")!).render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>,
  );
});
